export default __webpack_public_path__ + "static/media/Belt of the Black Warden.f4e04231.jpg";